/* eslint-disable no-console */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  createStyles,
  Header,
  Group,
  Text,
  MediaQuery,
  Burger,
  Space,
  Button,
  Menu,
  Avatar,
  Tabs,
  Image,
  Title,
} from '@mantine/core';
import { Users, Logout } from 'tabler-icons-react';
import { sendRequest } from '../services/services';
import Logo from '../image/hyperthings-logo.png';

const useStyles = createStyles((theme) => ({
  links: {
    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },
  logo: {
    [theme.fn.smallerThan('md')]: {
      position: 'relative',
      bottom: 35,
      // left: 10,
    },
  },
}));

const TopNav = ({
  opened,
  setOpened,
  appState,
  menuList,
  paymentStatus,
  ticketId,
  totalSeconds,
}) => {
  const navigate = useNavigate();

  const { classes } = useStyles();
  const [gateData, setGateData] = useState();

  const gateFunction = () => {
    const body = {
      gate: 'in' ? 'in' : 'out',
      cmd_type: '33' ? '33' : '11',
    };
    // mutate(`generate-otp`, () => {
    sendRequest(`http://192.168.0.186:9001/command-manager`, 'post', body)
      .then(({ data, code }) => {
        if (code === 20) {
          setGateData(data);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          // console.log('err', err?.response?.data?.code);
        }
      });
    // });
  };
  const status = `?is_online=${false}`;
  const shiftUpdate = () => {
    sendRequest(`/cashier/change-status${status}`, 'post')
      .then(({ msg }) => {
        if (msg === 'Profile online status updated successfully!') {
          // console.log('err', msg);
        }
      })
      .catch((err) => {
        if (err?.response?.data?.code) {
          // console.log('err', err?.response?.data?.code);
        }
      });
  };
  const getMenu = () => (
    <Group position="apart" spacing="xl" className={(classes.links, 'no-printme')}>
      <Tabs
        variant="pills"
        radius="xs"
        styles={(theme) => ({
          tab: {
            color: theme.black,
            backgroundColor: 'transparent',
            '&:hover': {
              color: theme.white,
              backgroundColor: theme.black,
            },
          },
        })}
        value={navigate.pathname}
        onTabChange={(value) => navigate(value)}
      >
        <Tabs.List>
          {[
            // eslint-disable-next-line consistent-return
            ...menuList.map((item) => {
              if (item !== null) {
                return (
                  <Tabs.Tab
                    key={`${item.path}-${item.label}`}
                    value={item.path}
                    {...(item.path === navigate.pathname
                      ? {
                          sx: (theme) => ({
                            color: `${theme.black} !important`,
                            backgroundColor: `${theme.white} !important`,
                          }),
                        }
                      : {})}
                  >
                    <Title order={6}>{item.label}</Title>
                  </Tabs.Tab>
                );
              }
            }),
          ]}{' '}
        </Tabs.List>
      </Tabs>
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Space w="xl" />
      <Button
        onClick={gateFunction}
        disabled={
          paymentStatus === 'pending' && totalSeconds <= 5
            ? null
            : paymentStatus === 'pending' || ticketId === null
        }
      >
        Gate
      </Button>
      {!appState?.isAuthenticated ? (
        navigate('/')
      ) : (
        <Menu trigger="hover">
          <Menu.Target>
            {appState?.first_name ? (
              <Text>Cashier</Text>
            ) : (
              <Avatar radius="xl" size="sm" src="https://ui-avatars.com/api/" />
            )}
          </Menu.Target>

          <Menu.Dropdown>
            {/* <Menu.Item icon={<Users size={20} />} onClick={() => navigate('/home')}>
              Profile
            </Menu.Item> */}
            <Menu.Item icon={<Users size={20} />}>
              <Text>{appState?.first_name}</Text>
            </Menu.Item>
            <Menu.Item
              icon={<Logout size={20} />}
              onClick={() => {
                shiftUpdate();
                sendRequest(`/users/logout`, 'PATCH')
                  .then(({ msg }) => {
                    if (msg === 'Logout successfully!') {
                      console.log('err', msg);
                    }
                  })
                  .catch((err) => {
                    if (err?.response?.data?.code) {
                      console.log('err', err?.response?.data?.code);
                    }
                  });
                localStorage.setItem('token', '');
                localStorage.setItem('userData', '');
                navigate('/');
              }}
            >
              Logout
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      )}
    </Group>
  );

  return (
    <Header
      className="no-printme"
      height={60}
      p="md"
      zIndex={40}
      fixed
      style={{
        height: '100%',
        backgroundColor: '#D9D9D9',
        zIndex: 20000,
        color: 'black',
      }}
    >
      <Group className="no-printme">
        {' '}
        <MediaQuery largerThan="md" styles={{ display: 'none' }}>
          <Burger
            opened={opened}
            onClick={() => setOpened((o) => !o)}
            size="md"
            color="#FFFFFF"
            mr="xl"
          />
        </MediaQuery>
        {/* <Text onClick={() => navigate('/home')}>New</Text> */}
        <Image
          src={Logo}
          onClick={() => navigate('/home')}
          width={150}
          style={{ marginTop: '-10px' }}
        />
        {getMenu()}
      </Group>
    </Header>
  );
};

export default TopNav;
